module.exports = __webpack_public_path__ + "media/hanabi100.7d3698cb.mp3";